import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../Table.css';
import DashboardLayout from '../Sidebar/DashboardLayout'; 
import ActionButtons from '../../commun/ActionButtons';
import { showDeleteConfirmation } from '../../commun/deletemsg';
import { generateRandomPassword } from '../../commun/generatepwd';
import useMessages from '../../../hooks/useMessages';
import GenericTable from '../../commun/GenericTable';
import Pagination from '../../commun/Pagination';
import TableFilterControls from '../../commun/TableFilterControls';
import ModalButton from '../../commun/ModalButton';
import FormInputMUI from '../../commun/FormInputMUI';
import { TextField, MenuItem, InputAdornment, IconButton } from '@mui/material';
import CustomAlert from '../../commun/CustomAlert';
import FormField from '../../Recruteur/candidat/AddTalent/FormField';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import Chatbox from '../../commun/ChatBox';

const API_BASE = process.env.REACT_APP_API_BASE_URL;
const UserDashboard = () => {
  const [displayMode, setDisplayMode] = useState('table');

  const { messages, handleError } = useMessages();
  const [page, setPage] = useState(1);
  const [users, setUsers] = useState([]);
  const [editingUserId, setEditingUserId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertSeverity, setAlertSeverity] = useState('success');
  const [showPassword, setShowPassword] = useState(false)
  const [selectedRows, setSelectedRows] = useState([]);
  const userRole = localStorage.getItem('userType');



  const [availableRoles, setAvailableRoles] = useState([]);

  useEffect(() => {
    axios.get(`${API_BASE}/api/roles`)
      .then(res => setAvailableRoles(res.data))
      .catch(err => console.error("Erreur chargement des rôles :", err));
  }, []);

  const [editFormData, setEditFormData] = useState({
    id: null,
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    role: '',
  });

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    role: 'admin',
    motDePasse: ''
  });

  const [searchTerm, setSearchTerm] = useState('');
  const [searchRole, setSearchRole] = useState('');

  const handleGenerate = () => {
    const randomPwd = generateRandomPassword();
    setFormData(prev => ({ ...prev, motDePasse: randomPwd }));
  };

  const handleInputChange = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const resetForm = () => {
    setFormData({
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      role: 'admin',
      motDePasse: ''
    });
    setErrors({});
  };

  useEffect(() => {
    axios.get(`${API_BASE}/api/user/all`)
      .then((response) => {
        setUsers(response.data)
      })
      .catch((error) => console.error('Erreur lors de la récupération des utilisateurs :', error));
  }, []);
  
  const filteredUsers = users.filter(user => {
    const fullName = (user.firstName + ' ' + user.lastName).toLowerCase();
    const matchesName = fullName.includes(searchTerm.toLowerCase());
    const matchesRole = searchRole ? user.role.toLowerCase() === searchRole.toLowerCase() : true;
    return matchesName && matchesRole;
  });

  const usersPerPage = 5;
  const paginatedUsers = filteredUsers.slice((page - 1) * usersPerPage, page * usersPerPage);
  const columns = [
    {
      key: 'name',
      label: 'Nom',
      render: (value, row) =>
        editingUserId === row._id ? (
          <>
            <input
              type="text"
              name="firstName"
              placeholder="Prénom"
              value={editFormData.firstName}
              onChange={handleEditFormChange}
              style={{ marginRight: '6px' }}
            />
            <input
              type="text"
              name="lastName"
              placeholder="Nom"
              value={editFormData.lastName}
              onChange={handleEditFormChange}
            />
          </>
        ) : (
          `${row.firstName} ${row.lastName}`
        )
    },
    {
      key: 'createdAt',
      label: "Date d'inscription",
      render: (value) => (value ? new Date(value).toLocaleDateString('fr-FR') : '—')
    },
    {
      key: 'phone',
      label: 'Téléphone',
           render: (value, row) =>
        editingUserId === row._id ? (
            <input
              type="text"
              name="phone"
              placeholder="Téléphone"
              value={editFormData.phone}
              onChange={handleEditFormChange}
              style={{ marginRight: '6px' }}
            />
        ) : (
          <a href={`tel:${row.phone}`} className="link-action">{row.phone}</a> 
        )
    },
    {
      key: 'email',
      label: 'Email',
      render: (value, row) =>
        editingUserId === row._id ? (
            <input
              type="text"
              name="email"
              placeholder="email"
              value={editFormData.email}
              onChange={handleEditFormChange}
              style={{ marginRight: '6px' }}
            />
        ) : (
          <a href={`mailto:${row.email}`} className="link-action">{row.email}</a> 
        )
    },
    {
      key: 'role',
      label: 'Rôle',
      render: (value, row) =>
        editingUserId === row._id ? (
          <select name="role" value={editFormData.role} onChange={handleEditFormChange}>
  {availableRoles.map(role => (
    <option key={role._id} value={role.name}>
      {role.name.charAt(0).toUpperCase() + role.name.slice(1)}
    </option>
  ))}
</select>

        ) : (
          value ? value.charAt(0).toUpperCase() + value.slice(1) : ''
        )
    },
    {
      key: 'statut',
      label: 'Statut',
      render: (value, row) => (
        <div
          className={value === 'active' ? 'statusActive' : 'statusInactive'}
          onClick={() => handleToggleStatus(row._id)}
          style={{ cursor: 'pointer' }}
        >
          {value === 'active' ? 'Active' : 'Inactive'}
        </div>
      )
    }
  ];

  const handleEdit = (userId) => {
    const userToEdit = users.find(user => user._id === userId);
    setEditingUserId(userId);
    setEditFormData({
      id: userId,
      firstName: userToEdit.firstName,
      lastName: userToEdit.lastName,
      phone: userToEdit.phone,
      email: userToEdit.email,
      role: userToEdit.role,
    });
  };

  const handleEditFormChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSaveEdit = async () => {
    try {
      const response = await axios.patch(`${API_BASE}/api/user/edituser/${editFormData.id}`, editFormData);
      const updatedUser = response.data;
      const updatedList = users.map(user =>
        user._id === updatedUser._id ? updatedUser : user
      );
      setUsers(updatedList);
      setEditingUserId(null);
    } catch (error) {
      console.error('Error updating user:', error);
    }
  };

  const handleCancelEdit = () => setEditingUserId(null);

  const handleToggleStatus = async (userId) => {
    const userToUpdate = users.find(user => user._id === userId);
    const updatedStatus = userToUpdate.statut === 'active' ? 'inactive' : 'active';
    const updatedUser = { ...userToUpdate, statut: updatedStatus };
    const updatedUsers = users.map(user =>
      user._id === userId ? updatedUser : user
    );
    setUsers(updatedUsers);
     
    try {
      await axios.patch(`${API_BASE}/api/user/update-status/${userId}`, {
        statut: updatedStatus,
      });
    } catch (error) {
      setAlertMessage("Failed to update status in database");
      setAlertSeverity("error");
      setAlertOpen(true);
      setUsers(users);
    }
  };

  const handleDelete = async (userId) => {
    showDeleteConfirmation({
      onConfirm: async () => {
        try {
          await axios.delete(`${API_BASE}/api/user/deleteuser/${userId}`);
          const updatedUsers = users.filter(user => user._id !== userId);
          setUsers(updatedUsers);
        } catch (error) {
          console.error('Error deleting user:', error);
        }
      },
      onCancel: () => {
        setAlertMessage("Suppression annulée");
        setAlertSeverity("error");
        setAlertOpen(true);
      }
    });
  };

  const handleModalSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      setAlertMessage("Veuillez corriger les erreurs dans le formulaire.");
      setAlertSeverity("error");
      setAlertOpen(true);
      return;
    }
    try {
      const formDataWithAdmin = {
        ...formData,
        isAdminSignup: true,
      };
      await axios.post(`${API_BASE}/api/auth/signup-user`, formDataWithAdmin);
      const updated = await axios.get(`${API_BASE}/api/user/all`);
      setUsers(updated.data);
      setShowModal(false);
      resetForm();
    } catch (error) {
      if (error.response?.status === 409) {
        setAlertMessage('Un utilisateur avec cet email existe déjà.');
        setAlertSeverity("error");
        setAlertOpen(true);
      } else {
        const errMsg =
          error?.response?.data?.errors?.phone?.message ||
          error?.response?.data?.message ||
          error.message;
        setAlertMessage(errMsg);
        setAlertSeverity("error");
        setAlertOpen(true);
      }
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.lastName.trim()) newErrors.lastName = "Ce champ est requis.";
    if (!formData.firstName.trim()) newErrors.firstName = "Ce champ est requis.";
    if (!formData.email.trim()) {
      newErrors.email = "Ce champ est requis.";
    } else if (!validateEmail(formData.email)) {
      newErrors.email = "Email invalide.";
    }
    if (!formData.phone.trim()) {
      newErrors.phone = "Ce champ est requis.";
    } else if (!validatePhone(formData.phone)) {
      newErrors.phone = "Numéro de téléphone invalide.";
    }
    if (!formData.motDePasse.trim()) {
      newErrors.motDePasse = "Le mot de passe est requis.";
    } else if (!validatePassword(formData.motDePasse)) {
      newErrors.motDePasse = "Le mot de passe doit comporter au moins 8 caractères.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const validatePhone = (phone) => /^\+?[0-9]{10,}$/.test(phone);
  const validatePassword = (password) => password.length >= 8;
const handleDeleteSelectedUsers = async () => {
  if (selectedRows.length === 0) return;

  showDeleteConfirmation({
    onConfirm: async () => {
      try {
        await Promise.all(
          selectedRows.map((userId) =>
            axios.delete(`${API_BASE}/api/user/deleteuser/${userId}`)
          )
        );
        const updatedUsers = users.filter(user => !selectedRows.includes(user._id));
        setUsers(updatedUsers);
        setSelectedRows([]);
        setAlertMessage("Utilisateurs supprimés avec succès.");
        setAlertSeverity("success");
        setAlertOpen(true);
      } catch (error) {
        setAlertMessage("Erreur lors de la suppression.");
        setAlertSeverity("error");
        setAlertOpen(true);
      }
    },
    onCancel: () => {
      setAlertMessage("Suppression annulée.");
      setAlertSeverity("info");
      setAlertOpen(true);
    }
  });
};

  return (
    <section className="dashboardContainer">
       <h3 className="componentTitle">Utilisateurs</h3>

      <div className="headerActions">
        <ModalButton onClick={() => setShowModal(true)} />

        <TableFilterControls
          searchValue={searchTerm}
          onSearchChange={setSearchTerm}
          statusValue={searchRole}
          onStatusChange={setSearchRole}
          statusLabel="Rôle"
          statusOptions={[
            { value: '', label: 'Tous' },
            ...availableRoles.map(role => ({
              value: role.name,
              label: role.name.charAt(0).toUpperCase() + role.name.slice(1)
            }))
          ]}
          
        />
      </div>

      <GenericTable
        displayMode={displayMode}
      setDisplayMode={setDisplayMode}
        columns={columns}
        data={paginatedUsers}
        renderActions={(row) => (
          <ActionButtons
            isEditing={editingUserId === row._id}
            onEdit={() => handleEdit(row._id)}
            onDelete={() => handleDelete(row._id)}
            onSave={handleSaveEdit}
            onCancel={handleCancelEdit}
            showView={false}
          />
        )}
        includeActions={true}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        onDeleteSelected={handleDeleteSelectedUsers}
        totalItems={users.length}
      />



      <Pagination page={page} setPage={setPage} totalItems={filteredUsers.length} itemsPerPage={usersPerPage} />

      {showModal && (
        <div className="modal-overlay" onClick={() => { setShowModal(false); resetForm(); }}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>Ajouter un utilisateur</h2>
              <form onSubmit={handleModalSubmit} className="application-form">
              <CustomAlert
                open={alertOpen}
                message={alertMessage}
                severity={alertSeverity}
                onClose={() => setAlertOpen(false)}
              />
                <FormInputMUI
                  label="Nom *"
                  value={formData.lastName}
                  onChange={(value) => handleInputChange('lastName', value)}
                  error={errors.lastName}
                />
                <FormInputMUI
                  label="Prénom *"
                  value={formData.firstName}
                  onChange={(value) => handleInputChange('firstName', value)}
                  error={errors.firstName}
                />

              <FormInputMUI
                label="Email *"
                type="email"
                value={formData.email}
                onChange={(value) => handleInputChange('email', value)}
                error={errors.email}
              />

              <div className="phone-user">
              <FormField
                type="phone"
                name="phone"
                value={formData.phone}
                onChange={(e) => handleInputChange(e.target.name, e.target.value)}
                error={errors.phone}
              />
              </div>
              <TextField
                select
                label="Rôle *"
                value={formData.role}
                onChange={(e) => handleInputChange('role', e.target.value)}
                fullWidth
                error={!!errors.role}
                helperText={errors.role}
                sx={{ mb: 2 }}
                SelectProps={{ MenuProps: { disablePortal: true } }}
              >
                {availableRoles.map(role => (
                  <MenuItem key={role._id} value={role.name}>
                    {role.name.charAt(0).toUpperCase() + role.name.slice(1)}
                  </MenuItem>
                ))}
              </TextField>

              <div className="password-field-wrapper">
              <TextField
                  label="Mot de passe *"
                  type={showPassword ? 'text' : 'password'}
                  value={formData.motDePasse}
                  onChange={(e) => handleInputChange("motDePasse", e.target.value)}
                  error={!!errors.motDePasse}
                  helperText={errors.motDePasse}
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword((prev) => !prev)}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  size="small"
                />
                <button
                  type="button"
                  className="generate-password-button"
                  onClick={handleGenerate}
                >
                  Générer
                </button>
              </div>

              <div className="button-container">
                <button type="button" onClick={() => { setShowModal(false); resetForm(); }} className="closeButton">Fermer</button>
                <button type="submit" className="submit-button">Confirmer</button>
              </div>
            </form>

          </div>
        </div>
      )}
      {userRole !== 'agent' && <Chatbox userRole={userRole} />}
      </section>
  );
};

const Users = () => (
  <DashboardLayout>
    <UserDashboard />
  </DashboardLayout>
);

export default Users;
